var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-box"},[_c('message-list',{ref:"messageList"}),_c('message-editor',{attrs:{"disabled":_vm.wait},on:{"onSend":_vm.onSend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }